import { BrowserRouter as Router, Route, Switch } from "react-router-dom"

// Components
import ScrollToTop from "./components/ScrollToTop"
import Header from "./components/Header"
import Showcase from "./components/Showcase"
import Services from "./components/Services"
import Testimonials from "./components/Testimonials"
import Groceries from "./components/Groceries"
import OrderForm from "./pages/OrderForm"
import Footer from "./components/Footer"

// Pages
import Routes from "./pages/Routes"

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />

      <Switch>
        <Route path="/" exact>
          <Showcase />
          <Services />
          <Groceries />
          <Testimonials />
        </Route>
        <Route path="/routes">
          <Routes />
        </Route>
        <Route path="/place-an-order">
          <OrderForm />
        </Route>
      </Switch>
      <Footer />
    </Router>
  )
}

export default App
